module.exports = __webpack_public_path__ + "static/media/AtlasTypewriter-Regular-Web.2b578a55.woff";